export default __webpack_public_path__ + "static/media/pacman-542x571.d1ba2533.png";